<template>
  <div class="voucher-cumluative-config">
    <b-modal
      ref="voucher-cumluative-modal"
      title="Cấu hình giá trị tích lũy voucher"
      size="lg"
      hide-footer
    >
      <b-button
        class="mb-4 font-weight-bolder"
        @click="onClickToAdd"
        size="sm"
        variant="primary"
      >
        <i style="font-size: 1rem" class="flaticon2-add-1"></i>Thêm mới
      </b-button>
      <b-table bordered hover :fields="fields" :items="cumluativeValues">
        <template v-slot:cell(quantityFrom)="row">
          <BInputNumber
            size="sm"
            v-model="row.item.quantityFrom"
            placeholder="Nhập SL từ"
            class="text-right"
          />
        </template>
        <template v-slot:cell(quantityTo)="row">
          <BInputNumber
            size="sm"
            v-model="row.item.quantityTo"
            placeholder="Nhập SL đến"
            class="text-right"
          />
        </template>
        <template v-slot:cell(cumulativeType)="row">
          <b-button-group size="sm" class="w-100">
            <b-button
              v-for="option in cumulativeTypeOptions"
              :key="option.value"
              :variant="
                row.item.cumulativeType === option.value
                  ? 'primary'
                  : 'outline-secondary'
              "
              class="font-weight-bolder"
              @click="onChangeCumulativeType(row.item, option.value)"
              >{{ option.text }}</b-button
            >
          </b-button-group>
        </template>
        <template v-slot:cell(cumulativeValue)="row">
          <b-input-group size="sm">
            <BInputNumber
              size="sm"
              v-model="row.item.cumulativeValue"
              :placeholder="
                isMoneyType(row.item) ? 'Nhập số tiền giảm' : 'Nhập % giảm'
              "
              class="text-right"
            />
            <b-input-group-append>
              <b-input-group-text>{{
                isMoneyType(row.item) ? 'đ' : '%'
              }}</b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </template>
        <template v-slot:cell(actions)="row">
          <v-icon
            small
            class="text-danger text-center"
            @click="deleteItemInArray(row.item.id)"
            v-b-tooltip
            title="Xóa"
            >mdi-delete</v-icon
          >
        </template>
      </b-table>
      <b-button
        style="fontweight: 600; width: 100px"
        variant="primary"
        size="sm"
        @click="onSave()"
        >Lưu</b-button
      >
      <b-button
        style="margin-left: 10px; font-weight: 600; width: 70px"
        variant="secondary"
        size="sm"
        @click="hideModal()"
        >Hủy</b-button
      >
    </b-modal>
  </div>
</template>
<script>
import { v4 } from 'uuid';
import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue';
import { cloneDeep, makeToastFaile } from '@/utils/common';
import { DISCOUNT_AMOUNT_TYPE } from '@/utils/enum';
import { getCumulativeType } from '@/utils/voucher-cumulative';

export default {
  data() {
    return {
      cumluativeValues: [],
      cumulativeTypeOptions: [
        { value: DISCOUNT_AMOUNT_TYPE.PERCENT, text: '%' },
        { value: DISCOUNT_AMOUNT_TYPE.MONEY, text: 'đ' },
      ],
      fields: [
        {
          key: 'quantityFrom',
          label: 'SL từ',
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
          tdClass: 'text-right',
        },
        {
          key: 'quantityTo',
          label: 'SL đến',
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
          tdClass: 'text-right',
        },
        {
          key: 'cumulativeType',
          label: 'Loại giá trị',
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
        },
        {
          key: 'cumulativeValue',
          label: 'Giá trị giảm',
          thStyle: { fontWeight: 600, color: '#181c32', width: '35%' },
          tdClass: 'text-right',
        },
        {
          key: 'actions',
          label: '',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '5%',
          },
        },
      ],
    };
  },
  methods: {
    showModal(voucherCumluativeValues) {
      // Mốc cũ chưa có loại giá trị → mặc định %
      this.cumluativeValues = cloneDeep(voucherCumluativeValues).map((item) => ({
        ...item,
        cumulativeType: getCumulativeType(item),
      }));
      this.$refs['voucher-cumluative-modal'].show();
    },
    hideModal() {
      this.$refs['voucher-cumluative-modal'].hide();
    },
    onSave() {
      const invalidItem = this.cumluativeValues.find((item) => {
        const value = Number(item.cumulativeValue) || 0;
        return this.isMoneyType(item) ? value <= 0 : value <= 0 || value > 100;
      });
      if (invalidItem) {
        return makeToastFaile(
          this.isMoneyType(invalidItem)
            ? 'Số tiền giảm phải lớn hơn 0!'
            : 'Phần trăm giảm phải từ 1 đến 100!',
        );
      }
      this.$emit('receive-cumulative', this.cumluativeValues);
      this.hideModal();
    },
    onClickToAdd() {
      this.cumluativeValues.push({
        id: v4(),
        quantityFrom: 0,
        quantityTo: 0,
        cumulativeType: DISCOUNT_AMOUNT_TYPE.PERCENT,
        cumulativeValue: 0,
      });
    },
    isMoneyType(item) {
      return item.cumulativeType === DISCOUNT_AMOUNT_TYPE.MONEY;
    },
    onChangeCumulativeType(item, cumulativeType) {
      if (item.cumulativeType === cumulativeType) return;
      item.cumulativeType = cumulativeType;
      // Đổi loại thì giá trị cũ không còn đúng nghĩa (10% ≠ 10đ) → nhập lại
      item.cumulativeValue = 0;
    },
    deleteItemInArray(id) {
      for (var i = 0; i < this.cumluativeValues.length; i++) {
        if (this.cumluativeValues[i].id === id) {
          this.cumluativeValues.splice(i, 1);
        }
      }
      this.cumluativeValues.forEach((element, index) => {
        element.level = index + 1;
      });
    },
    onCallApiSuccess() {
      this.hideModal();
      this.$emit('on-submit-success');
    },
  },
  components: {
    BInputNumber,
  },
};
</script>